import { render, staticRenderFns } from "./ProductDetailCoupon.vue?vue&type=template&id=0ef2b9ac&scoped=true"
import script from "./ProductDetailCoupon.vue?vue&type=script&lang=js"
export * from "./ProductDetailCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef2b9ac",
  null
  
)

export default component.exports